import {createResource, getResource, Phone} from "./common"

export type EmailOutreachSettings = {
	type: "emailOutreachSettings"
	id: string
	attributes: {
		createdAt: Date
		updatedAt: Date
		name: string
		domain: string
		sender: {
			email: string
			name?: string
		}
		isVerified: boolean
		isDefault: boolean
		dnsRecords?: {
			isValid: boolean
			recordType: string
			key: string
			value: string
		}[]
	}
}

// TODO: this is sms outreach, do later
export type MessageOutreachSettings = {
	type: "messageOutreachSettings"
	id: string
	attributes: {
		createdAt: Date
		updatedAt: Date
		name: string
		senderPhone: Phone
		isDefault: boolean
	}
}

export type CreateEmailOutreachSettingsAttributes = {
	name: string
	domain: string
	sender: {
		email: string
		name?: string
	}
}

export type OutreachSettings = EmailOutreachSettings | MessageOutreachSettings

export function isEmailOutreachSettings(item: OutreachSettings): item is EmailOutreachSettings {
	return item.type === "emailOutreachSettings"
}

export function isMessageOutreachSettings(item: OutreachSettings): item is MessageOutreachSettings {
	return item.type === "messageOutreachSettings"
}

export async function createEmailOutreachSettings(
	accessToken: string,
	createAttributes: CreateEmailOutreachSettingsAttributes
) {
	const result = await createResource<OutreachSettings>(`outreach-settings`, accessToken, {
		type: "emailOutreachSettings",
		attributes: createAttributes,
	})
	return result.map((v) => v.data)
}

export async function getOutreachSettingsList(accessToken: string) {
	const result = await getResource<OutreachSettings[]>("outreach-settings", accessToken)
	return result.map((v) => v.data)
}

export async function getOutreachSettings(accessToken: string, id: string) {
	const result = await getResource<OutreachSettings>(`outreach-settings/${id}`, accessToken)
	return result.map((v) => v.data)
}

export async function makeOutreachSettingsDefault(accessToken: string, id: string) {
	const result = await createResource<OutreachSettings>(`outreach-settings/${id}/default`, accessToken, {})
	return result.map((v) => v.data)
}

export async function verifyOutreachSettings(accessToken: string, id: string) {
	const result = await createResource<OutreachSettings>(`outreach-settings/${id}/verify`, accessToken, {})
	return result.map((v) => v.data)
}
